import React, {useEffect, useRef, useState} from 'react';
import "./mainMobile.css"
import Header from "../components/Header";
import footer_logo from "./images/footer_logo.svg"
import main_bg from "./images/main_bg.png"
import main_block_bg from "./images/main_page_bg.svg"
import details_icon1 from "./images/Icon1.svg"
import details_icon2 from "./images/Icon2.svg"
import details_icon3 from "./images/Icon3.svg"
import details_icon4 from "./images/Icon4.svg"
import mobile_donations from "./images/mobile_donations.png"
import faq_plus from "./images/faq_plus.svg"
import lite_details from "./images/Undura_lite_details.svg"
import undura_big_logo from "./images/Undura_big_logo.svg"
import lite_details_icon1 from "./images/Icon1_1.svg"
import lite_details_icon2 from "./images/Icon1_2.svg"
import lite_details_icon3 from "./images/Icon1_3.svg"
import lite_details_icon4 from "./images/Icon1_4.svg"
import donation_details_icon1 from "./images/Icon2_1.svg"
import donation_details_icon2 from "./images/Icon2_2.svg"
import donation_details_icon3 from "./images/Icon2_3.svg"
import donation_details_icon4 from "./images/Icon2_4.svg"
import donations_logo1 from "./images/1.png"
import donations_info from "./images/donation_info.svg"
import check_img from "./images/check_img.svg"
import info_donation_platform from "./images/info_donation_platform.svg"
import undura_roadmap from "./images/RoadMap.svg"
import mobile_undura_lite from "./images/mobile_undera_lite_image.svg"
import waves_bg from "./images/waves_bg.svg"
import ProjectCard from "./components/ProjectCard";
import FaqItem from "./components/FaqItem";
import Footer from "../components/Footer";
import "./mainMobile.css"
import {motion} from "framer-motion";
import circles_bg from "../ForDonors/images/circles.svg";
import PageLoader from "../components/PageLoader";
import DevelopmentButton from "../components/DevelopmentButton";
import Roadmap from "../components/ImprovedRoadmap";

const MainPage = () => {


    const initial = {opacity: 0, y: 40}
    const whileInView = {opacity: 1, y: 0}
    const transition = {duration: 0.8, ease: "easeOut", delay:0.1}
    const viewport = {once: true}


    const roadmap = [
        { label: "Compilation and verification of documentation: KYC/KYB/AML policies, conflict-of-interest management (Art. 8), KIIS/disclosures, marketing fairness and clarity, agreements with EMI/PI, continuity plan and backup-servicer arrangement (Art. 12), GDPR compliance framework.\n" +
                "Pre-licensing consultations and submission of the application package.", date: "ECSPR: Preparation and Application in Lithuania", branch: "up",  open: true},

        { label: "Completion of the Lite Hub UI and connection to the underlying infrastructure: multi-tenant architecture, Undura ID, transparent non-security donation flows, and recipient reporting.", date: "Launch of Lite Interface and Hub", branch: "down" },
        { label: "Definition of service perimeter (e.g., order reception and transmission, secondary layer), best-execution policy, product and client categorization, transaction reporting procedures (RTS/ITS), capital and competency requirements. Compilation of evidence and submission for authorization.", date: "MiFID II: Preparation and Application in Germany" , branch: "up", open: true},
        { label: "Finalization of the core modules: Risk & Compliance, Data Integrity, Continuity & Custody, Settlement & Ledger, Growth & Competence, API & Expansion.\n" +
                "Integration with KYC/EMI providers, resilience testing (RPO/RTO), audit trails, penetration testing, target SLO/SLA.\n" +
                "Preparation for operational and regulatory audits.", date: "Completion of Core and Hub Development" , branch: "down", open: true},
        { label: "Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, expansion of Settlement & Ledger Core. Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, and expansion of the Settlement & Ledger Core. Completion and testing of the secondary market layer, followed by its official launch after obtaining the MiFID II license.", date: "MiFID Modules and Secondary Market" , branch: "up"},
        { label: "Technical and legal feasibility study of compatibility: fund structures and risk management (AIFM), financial data access and exchange (FiDA).\n" +
                "Design of adapters, prototype reporting schemes, and data interface alignment.", date: "Research of AIFM and FiDA Modules" , branch: "down", open: true},
        { label: "Localization for neighboring jurisdictions: partnerships with local EMI/KYC providers, data storage and compliance requirements, mapping of reporting and legal structures. Gradual rollout of white-label network nodes in non-EU markets.", date: "Expansion Beyond the EU" , branch: "up"},
    ];
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.pageX - wrapperRef.current.offsetLeft;
        scrollLeft.current = wrapperRef.current.scrollLeft;
    };

    const onMouseMove = (e) => {
        if (!isDragging.current) return;
        const x = e.pageX - wrapperRef.current.offsetLeft;
        const walk = x - startX.current;
        wrapperRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const onMouseUp = () => {
        isDragging.current = false;
    };
    const wrapperRef = useRef(null);



    useEffect(() => {
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({behavior: "smooth"});
                }, 300);
            }
        }
    }, []);

    const isMobile = window.innerWidth < 768;
    const [popupActiveButton, setPopupActiveButton] = useState(false);
    const popupClassesButton = `popup_development_button ${popupActiveButton ? "activated" : ""}`;
    const faq_items = [
        {
            question: "How does UNDURA verify projects?",
            answer: "Each project is verified through our KYB process and partnership checks.\n" +
                "We only list organizations with transparent records and verified payment accounts.\n" +
                "You can also find detailed information and verification status in each project’s description."
        },
        {
            question: "Can I get a tax deduction?",
            answer: "Tax deductions depend on the organization’s legal status and your country’s tax laws. Registered charities on Undura Lite can issue donation receipts that donors may use for tax purposes."
        },
        {
            question: "How can I track the results?",
            answer: "You’ll get updates and reports directly from the organization in your donor dashboard."
        },
        {
            question: "What payment methods are supported?",
            answer: "Donations are processed securely via Stripe — credit card, Apple Pay, and Google Pay."
        },
        {
            question: "Are there limits on the donation amount?",
            answer: "There’s no minimum.\nFor donations above €300, identity verification may be requested for security reasons."
        }
    ];
    const pointVariants = {
        hidden: {opacity: 0, y: 20},
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {delay: i * 0.15, duration: 0.6, ease: "easeOut"}
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: {once: true},
        variants: pointVariants
    };

    const fadeUp = {
        initial: {opacity: 0, y: 40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeDown = {
        initial: {opacity: 0, y: -40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeLeft = {
        initial: {opacity: 0, x: -50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeRight = {
        initial: {opacity: 0, x: 50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };


    const fadeCircles = {
        initial: {opacity: 0, x: 50, width: "240%"},
        whileInView: {opacity: 1, x: 0, width: "100%"},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };


    const details = [
        {
            name: "Sign Up",
            text: "Register your organization and choose a design template. Add your logo, colors, and basic details — we’ll take it from here."
        },
        {
            name: "Configuration",
            text: "Our team prepares your platform, applies branding, and connects payments. You can track progress right in your dashboard."
        },
        {
            name: "Review & Launch",
            text: "Once everything is ready, you’ll preview and approve the final version. After that — your page goes live in the Undura network."
        },
        {
            name: "Full donations, fair costs",
            text: "Donations go fully to your cause. Larger platforms only cover real hosting expenses — no markup, no hidden fees."
        }
    ];


    return (
        <div className="main_page">
            <PageLoader/>

            <motion.img src={main_block_bg} alt="" className="main_block_bg" {...fadeDown}/>
            <Header/>

            <motion.div className="powered_by" {...fadeUp}>
                <div className="circle"></div>
                Powered by Undura Lite
            </motion.div>

            <motion.div className="main_text" {...fadeLeft}>
                <span>One infrastructure. Infinite impact.</span><br/>
                Your transparent foundation for donations.
            </motion.div>

            <motion.div className="about_undura_main" {...fadeRight}>
                Undura Lite helps organizations and communities build transparent support platforms — no code, no fees,
                full ownership.
            </motion.div>

            <motion.div className="main_block_buttons" {...fadeUp}>

                <DevelopmentButton className="get_started">
                    Get started
                </DevelopmentButton>
                <a href="#">
                    <DevelopmentButton className="explore_demo">
                        Explore demo
                    </DevelopmentButton>
                </a>
            </motion.div>

            <motion.div className="main_bg_block" {...fadeDown}>
                <img src={main_bg} alt="" className="main_bg"/>
            </motion.div>

            <motion.div className="main_text" {...fadeLeft}>
                <span>Your platform — ready in one day.</span><br/>
                No code, no fees, full support.
            </motion.div>

            <motion.div className="about_platform_details" {...(!isMobile ? fadeLeft : {})}>
                {details.map((item, idx) => (
                    <motion.div
                        className="details_block"
                        key={idx}
                        {...fadeNumeric}
                        custom={idx}
                    >
                        <div className="icons_block">
                            <div className="details_icon"><img
                                src={[details_icon1, details_icon2, details_icon3, details_icon4][idx]} alt=""/></div>
                            <div className="details_number">{`0${idx + 1}`}</div>
                        </div>
                        <div className="details_text">
                            <div className="details_block_name">{item.name}</div>
                            {item.text}
                        </div>
                    </motion.div>
                ))}
            </motion.div>

            <DevelopmentButton className="create_platform_button pos_center_popup">
                Get started
            </DevelopmentButton>

            <motion.div className="main_text" {...fadeLeft}>
                How Our<span> LITE</span><br/> Infrastructure Works
            </motion.div>

            <motion.div className="infrastructure_details" {...fadeRight}>
                Donations flow directly between people and organizations. Undura Lite provides the secure, transparent
                infrastructure that keeps everything running smoothly — without taking a cut.
            </motion.div>

            <motion.div className="lite_v_image" {...fadeUp}>
                {window.innerWidth >= 768 ? <img src={lite_details} alt=""/> : <img src={mobile_undura_lite} alt=""/>}
            </motion.div>

            <motion.div className="why_undura_block" {...fadeLeft}>
                <div className="why_undura">
                    <div className="why_undura_details">
                        <div className="undura_lite_h1">Why Undura Lite</div>
                        <div className="undura_lite_text">A transparent way to fund what matters</div>
                        <div className="undura_lite_blocks">
                            {[lite_details_icon1, lite_details_icon2, lite_details_icon3, lite_details_icon4].map((icon, idx) => (
                                <motion.div className="undura_lite_block" key={idx} {...fadeNumeric} custom={idx}>
                                    <div className="name"><img src={icon}
                                                               alt=""/>{["No commission", "White-Label", "Security", "Fast Launch"][idx]}
                                    </div>
                                    <div
                                        className="details">{["Just transparent infrastructure supported by community tips.", "Your brand, your domain, your control.", "GDPR and Stripe-verified payment protection.", "Ready in one day — we handle the setup."][idx]}</div>
                                </motion.div>
                            ))}
                        </div>
                        <DevelopmentButton className="create_platform_lite">Create platform</DevelopmentButton>
                    </div>
                    <div className="undura_big_logo"><img src={undura_big_logo} alt=""/></div>
                </div>
            </motion.div>

            {/* Далее все блоки с fadeLeft/fadeRight/fadeUp */}
            <motion.div className="for_donors" {...fadeUp}>
                <div className="circle"></div>
                For Donors
            </motion.div>
            <motion.div className="main_text" {...fadeLeft}>How people give through Undura</motion.div>

            <div className="donations_logo">
                <motion.div className="donations_logo_image" {...fadeRight}>
                    {isMobile ? <img src={mobile_donations} alt=""/> : <img src={donations_logo1} alt=""/>}
                </motion.div>

                <div className="donations_details">
                    {[donation_details_icon1, donation_details_icon2, donation_details_icon3, donation_details_icon4].map((icon, idx) => {
                        const content = (
                            <div className="details_block" key={idx}>
                                <div className="icons_block">
                                    <div className="details_icon"><img src={icon} alt=""/></div>
                                </div>
                                <div className="details_text">
                                    <div className="details_block_name">
                                        {["They choose a verified project.", "They donate transparently through Undura", "They track progress in real-time.", "They receive reports from the organization."][idx]}
                                    </div>
                                    {["Browse trusted initiatives from officially verified organizations.", "Make a contribution in just a few clicks — with no fees or hidden charges.", "See how every contribution moves the project forward.", "After the campaign ends, donors receive an official summary of how funds were used."][idx]}
                                </div>
                            </div>
                        );

                        // Если мобильная версия — просто выводим без анимации
                        return isMobile ? content :
                            <motion.div {...{...fadeUp, transition: {...fadeUp.transition, delay: idx * 0.15}}}
                                        key={idx}>{content}</motion.div>;
                    })
                    }
                </div>
            </div>

            <motion.div className="donations_info" {...fadeUp}>
                <div className="donations_info_flex">
                    <img src={donations_info} alt=""/>
                    <div className="donations_info_text">
                        All of this is done without margins, hidden fees, or intermediaries.
                    </div>
                </div>
                <a href="/for-organizations">
                    <motion.div className="learn_more" whileHover={{scale: 1.05}}>Learn more</motion.div>
                </a>
            </motion.div>

            {/* <motion.div className="powered_by_mt0" {...fadeUp}>
                <div className="circle"></div>
                Powered by Undura Lite
            </motion.div>
            <motion.div className="main_text" {...fadeLeft}>Projects making <span>a difference</span></motion.div>

            <motion.div className="project_examples main_page_examples">
                {[0, 1, 2, 3].map((e) => <ProjectCard animation={fadeNumeric} custom={e}/>)}


            </motion.div>

            <motion.div className="project_show_more" {...fadeUp} whileHover={{scale: 1.05}}>Show more</motion.div>
*/}
            <div className="your_donation">
                <motion.div className="your_donation_info" {...fadeLeft}>
                    <div className="your_donation_main">Your own donation platform — ready in one day</div>
                    <div className="your_donation_desc">Bring your mission closer to people who care</div>
                    <div className="your_donation_points">
                        {[check_img, check_img, check_img, check_img].map((img, idx) => (
                            <div className="point" key={idx}><img src={img}
                                                                  alt=""/>{["Custom Domain", "Brand Customization", "Ready Templates", "Simple Analytics"][idx]}
                            </div>
                        ))}
                    </div>
                    <DevelopmentButton className="start_now_button pos_left_popup">Start now</DevelopmentButton>
                </motion.div>
                <motion.div className="info_donation_img" {...fadeRight}><img src={info_donation_platform} alt=""/>
                </motion.div>
            </div>

            <motion.div className="main_text" {...fadeLeft}>Questions you might have</motion.div>
            <motion.div className="faq_full" {...fadeUp}>
                <div className="faq_main">{faq_items.map((e, i) => <FaqItem key={i} answer={e.answer}
                                                                            question={e.question}/>)}</div>
                <motion.div className="bg_circles" {...fadeUp}><img alt="" src={circles_bg}/></motion.div>
            </motion.div>

            <motion.div className="main_text" {...fadeLeft}>Undura <span>Roadmap</span></motion.div>
            <motion.div className = "roadmap_fs_block" initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}
                        ref={wrapperRef}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseUp}
                        onMouseUp={onMouseUp}
                        style={{
                            overflowX: "auto !important",
                            overflowY: "hidden",
                            //cursor: isDragging.current ? "grabbing" : "grab"
                        }}
            >
                <Roadmap items={roadmap} />
            </motion.div>

            <motion.div className="no_coding_block" {...fadeUp}>
                <div className="no_coding_content">
                    <img src={waves_bg} alt="" className="waves_last"/>
                    <div className="powered_by_last">
                        <div className="circle"></div>
                        Powered by Undura Lite
                    </div>
                    <div className="no_coding_name">No coding. <br/>No hidden fees.</div>
                    <div className="no_coding_text">Start free — and grow on your own terms.</div>
                    <DevelopmentButton className="start_now_button_last pos_center_popup">Start now</DevelopmentButton>
                </div>
            </motion.div>

            <Footer mode="lite"/>
        </div>
    );
};

export default MainPage;